<div class="bg-gray-50 text-gray-800">
  <!-- Hero Section -->
  <section class="px-4 py-32 grid grid-cols-1 md:grid-cols-1 gap-8 items-center"
    style="background-image: linear-gradient(to bottom, black, transparent), url('https://img.freepik.com/free-photo/futuristic-view-high-tech-earth-planet_23-2151100414.jpg?t=st=1746474119~exp=1746477719~hmac=45c7f8eb3fd4bf011d40373c2a08a3245efb898ffa65445ec0e0c425939bd83d&w=996');background-size:cover;background-position: center;background-attachment: fixed">
    <div class="mt-10 max-w-7xl mx-auto py-16 px-8 bg-white/60 backdrop-blur-md rounded-lg text-black text-center"
      style="background: #ffffff1f;">
      <h1 class="text-6xl text-white md:text-5.5xl font-bold leading-tight">
        Thrive in the Era of Generative Intelligence
      </h1>
      <p class="mt-6 text-xxl text-gray-100">
        Unlock the power of Artificial Intelligence and Machine Learning to transform your business.
      </p>
      <button routerLink="/contact-us.html"
        class="mt-8 px-6 py-5 text-white rounded-md transition hover:!bg-white hover:text-black"
        style="background: linear-gradient(135deg, #e83d2e 0%, #bf0040 100%);">
        Get a Free Consultation
      </button>
      <!-- style="background: linear-gradient(135deg, #e83d2e 0%, #bf0040 100%);" -->
    </div>
    <!-- <div>
        <img src="https://www.openxcell.com/wp-content/uploads/2023/12/AI-ML-service-Banner.webp" alt="AI Solutions" class="w-full h-auto rounded-md shadow-lg"> 
      </div> -->
  </section>


  <section
    class=" flex flex-col lg:flex-row items-center justify-between bg-cover bg-center bg-no-repeat px-4 py-10 lg:px-20 lg:py-16">

    <!-- <div class="absolute inset-0 bg-white/70 backdrop-blur-sm z-0"></div> -->

  <div class="container relative">
    <div class="flex md:flex-row flex-col">
        <!-- Left Content Box -->
    <div class="md:absolute static z-10 bg-black text-white p-3 lg:p-6 md:max-w-xl max-w-full flex justify-center flex-col md:rounded-lg w-full top-0 bottom-0 my-auto left-20 content-box">
      <h2 class="text-2xl lg:text-3xl font-bold leading-snug mt-2">
        AI Bot for Auto Query<br />
        Resolution & User Retention
      </h2>
      <p class="text-base lg:text-lg mt-4 leading-relaxed">
        Make website navigation interactive with a conversational AI chatbot trained on your website data. Improve
        engagement and conversion rates with an easy-to-use dashboard and relevant response generation. Additionally,
        the bot offers an accessible backend and requires no technical expertise for fine-tuning. This AI chatbot can be
        a game changer for your website visitors.
      </p>
      <a href="#" class="inline-flex items-center text-blue-500 mt-3 font-medium hover:underline">
        View More
        <svg class="ml-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M12.293 4.293a1 1 0 011.414 0L18 8.586a1 1 0 010 1.414l-4.293 4.293a1 1 0 11-1.414-1.414L15.586 10H4a1 1 0 110-2h11.586l-3.293-3.293a1 1 0 010-1.414z"
            clip-rule="evenodd" />
        </svg>
      </a>
    </div>

    <!-- Right Image Box -->
    <div class=" md:max-w-3/4 md:ml-auto md:w-3/4 image-box w-full">
      <img src="../../../assets/images/xplore-gpt.png" alt="AI Chatbot Screenshot"
        class="w-full h-auto rounded-xl shadow-md " />
    </div>
    </div>
  </div>
  </section>



  <!-- Feature Blocks -->
  <section class="bg-white py-16">
    <div class="max-w-7xl mx-auto px-4 gap-8">
      <h2 class="text-5xl md:text-5xl font-bold text-gray-900 mb-4 text-center text-uppercase">
        Why Clients Choose Vidhema for AI & GenAI Solutions
      </h2>
      <p class="text-xxl text-gray-600 mb-8 max-w-4xl text-center mx-auto">
        Organizations partner with Vidhema to unlock the full potential of Generative AI through secure, scalable, and
        transformational solutions rooted in responsible innovation.
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-8 px-4 md:px-4 lg:px-4 bg-white">

        <div class="text-center bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold">Secure & Scalable AI</h3>
          <p class="mt-2 text-gray-600">Built on Responsible AI with strong governance and change management.</p>
        </div>

        <div class="text-center bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold">Enterprise Innovation</h3>
          <p class="mt-2 text-gray-600">Transformative AI for front-office and value-stream innovation.</p>
        </div>

        <div class="text-center bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold">Data Complexity Expertise</h3>
          <p class="mt-2 text-gray-600">Mastering unstructured and fragmented data for reliable outcomes.</p>
        </div>

        <div class="text-center bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold">Modern IT Landscape</h3>
          <p class="mt-2 text-gray-600">Eliminate tech debt through IT modernization and integration.</p>
        </div>

        <div class="text-center bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold">Flexible Delivery</h3>
          <p class="mt-2 text-gray-600">Support for on-prem, cloud, hybrid, and multi-modal deployments.</p>
        </div>

        <div class="text-center bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold">High-Performance Solutions</h3>
          <p class="mt-2 text-gray-600">Optimized for speed, scale, and enterprise-grade performance.</p>
        </div>

      </div>

    </div>
  </section>

  <!-- Solutions Grid -->
  <section class="bg-gray-50 py-16 px-4">
    <div class="max-w-7xl mx-auto text-center">
      <h2 class="text-5xl font-bold text-gray-900 mb-4 text-uppercase">AI & ML Solutions We Offer</h2>
      <p class="text-lg text-xxl text-gray-600 mb-12">Harness cutting-edge technologies to build smarter, faster, and
        more predictive systems.</p>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

        <div class="rounded-lg shadow-md p-6 hover:shadow-lg transition " style="background: #39005e;">
          <h3 class="text-3xl text-white font-semibold mb-2">Predictive Analytics</h3>
          <p class="text-gray-100">Use historical data to forecast future trends and gain actionable insights.</p>
        </div>

        <div class="rounded-lg shadow-md p-6 hover:shadow-lg transition"
          style="background-image: url(https://dynamicmedia.accenture.com/is/image/accenture/ACN_Light-Gradient2_640x904%3Arad-card-full?ts=1743483743288&fit=constrain&dpr=off);">
          <h3 class="text-3xl font-semibold text-gray-800 mb-2">Natural Language Processing (NLP)</h3>
          <p class="text-gray-600">Empower systems to understand, interpret, and generate human language.</p>
        </div>

        <div class="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition" style="background: #39005e;">
          <h3 class="text-3xl font-semibold text-white mb-2">Computer Vision</h3>
          <p class="text-gray-100">Leverage image and video analysis for facial recognition, defect detection, and more.
          </p>
        </div>

        <div class="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition" style="background: #f8f8f8;">
          <h3 class="text-3xl font-semibold text-gray-800 mb-2">Chatbot & Virtual Assistants</h3>
          <p class="text-gray-600">Automate customer support and engagement with AI-powered assistants.</p>
        </div>

        <div class="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
          <h3 class="text-3xl font-semibold text-gray-800 mb-2">Recommendation Engines</h3>
          <p class="text-gray-600">Deliver personalized user experiences with intelligent recommendation systems.</p>
        </div>

        <div class="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition"
          style="background-image: url(https://dynamicmedia.accenture.com/is/image/accenture/ACN_Light-Gradient2_640x904%3Arad-card-full?ts=1743483743288&fit=constrain&dpr=off);">
          <h3 class="text-3xl font-semibold text-gray-800 mb-2">AI-Powered Automation</h3>
          <p class="text-gray-600">Enhance efficiency with smart process automation using machine learning models.</p>
        </div>

      </div>
    </div>
  </section>


  <!-- Industry Cards -->
  <section class="bg-white py-16 px-4">
    <div class="max-w-7xl mx-auto text-center">
      <h2 class="text-5xl font-bold text-gray-900 mb-4 text-uppercase">Industries We Serve</h2>
      <p class="text-lg text-xl text-gray-600 mb-12">Driving innovation across diverse sectors with AI & ML solutions.
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-left">

        <!-- Healthcare -->
        <div class="flex items-start gap-5 p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all">
          <svg class="w-40 h-40 text-blue-600" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 12h8m-4-4v8m9-4a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <h3 class="text-3xl font-semibold text-gray-800">Healthcare</h3>
            <p class="text-gray-600">AI-driven diagnostics, virtual assistants, patient monitoring, and EHR systems.</p>
          </div>
        </div>

        <!-- Finance -->
        <div class="flex items-start gap-5 p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all">
          <svg class="w-40 h-40 text-green-600" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 18V10m4 8V6m4 12v-4m4 4V8m4 10V4" />
          </svg>
          <div>
            <h3 class="text-3xl font-semibold text-gray-800">Finance</h3>
            <p class="text-gray-600">Fraud detection, credit scoring, algorithmic trading, and automation.</p>
          </div>
        </div>

        <!-- Retail -->
        <div class="flex items-start gap-5 p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all">
          <svg class="w-40 h-40 text-yellow-500" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h18M6 7h12M4 11h16v8H4z" />
          </svg>
          <div>
            <h3 class="text-3xl font-semibold text-gray-800">Retail</h3>
            <p class="text-gray-600">Personalized shopping, customer analytics, and inventory forecasting.</p>
          </div>
        </div>

        <!-- Manufacturing -->
        <div class="flex items-start gap-5 p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all">
          <svg class="w-40 h-40 text-indigo-600" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 11l7-7 7 7v7a2 2 0 01-2 2H7a2 2 0 01-2-2v-7z" />
          </svg>
          <div>
            <h3 class="text-3xl font-semibold text-gray-800">Manufacturing</h3>
            <p class="text-gray-600">Predictive maintenance, robotics, and quality control with computer vision.</p>
          </div>
        </div>

        <!-- Education -->
        <div class="flex items-start gap-5 p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all">
          <svg class="w-40 h-40 text-purple-600" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3l9 4.5-9 4.5-9-4.5L12 3zM12 12v7" />
          </svg>
          <div>
            <h3 class="text-3xl font-semibold text-gray-800">Education</h3>
            <p class="text-gray-600">Smart learning tools, adaptive platforms, and content recommendations.</p>
          </div>
        </div>

        <!-- Logistics -->
        <div class="flex items-start gap-5 p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all">
          <svg class="w-40 h-40 text-red-600" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 16V8a1 1 0 011-1h4l2-2h4l2 2h4a1 1 0 011 1v8M3 16l2 3h14l2-3" />
          </svg>
          <div>
            <h3 class="text-3xl font-semibold text-gray-800">Logistics</h3>
            <p class="text-gray-600">AI for smart warehousing, route optimization, and fleet management.</p>
          </div>
        </div>

      </div>
    </div>
  </section>



  <!-- CTA Section -->
  <section class="bg-blue-600 py-16 text-white text-center">
    <h2 class="text-3xl md:text-4xl font-bold">Looking to build an AI-powered application?</h2>
    <p class="mt-4 text-lg">Let's discuss your business idea and build a solution together.</p>
    <button class="mt-8 px-6 py-3 bg-white text-blue-600 font-semibold rounded hover:bg-gray-100 transition">
      Book a Free Call
    </button>
  </section>
</div>